import React from "react";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const About = () => {
    const options = {
        loop: true,
        margin: 20, // Margin thoda badhaya taaki items chipke na
        nav: false, // Mobile friendly carousels me nav arrows ki jagah dots achhi lagti hain
        dots: true,
        autoplay: true,
        autoplayTimeout: 2000,
        responsive: {
            0: { items: 2 },   // Mobile par kam se kam 2 logo dikhne chahiye size ke hisab se
            576: { items: 3 }, // Small tablets
            768: { items: 4 }, // Large tablets
            1000: { items: 5 } // Desktop
        }
    }

    return (
        <>
            <div className="about-main" id="about">
                <div className="container">
                    <div className="about-inner">
                        <div className="title1" data-aos="fade-left">
                            <div className="title-inner">
                                <span>About Us</span>
                                <h2>Dan Halsman</h2>
                            </div>
                        </div>
                        <div className="context">
                            <p>Quisque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Etiam et
                                odio sedan arami accumsan gravida. Mauris in rhoncus mauris. Duis a massa ac ex malesuada
                                aliquet. Mauris odio in devam company the design dolor leo facilisis ligula eget malesuada metus
                                ununc posuere velsem.
                            </p>
                            <p>
                                Aliquam erat volutpat. Curabitur tortor mauris, iaculis vel pulvinar at, convallis id mauris.
                                Praesent feugiat dui sit amet ullamcorper blandit ligula ligula volutpat ante sed rhoncus nunc
                                ante non ex. Donec porta elementum estid suscipit nisl bibendum vitae. Sedet nisi lacinia the
                                adam drana diam.</p>
                        </div>
                        <div className="title1">
                            <div className="title-inner">
                                <span>Our Awards</span>
                            </div>
                        </div>
                        <div className="about-logo">
                            <div className="logo-main">
                                <OwlCarousel className='owl-theme item-m' {...options}>
                                    <div className="item"><a href="#"><img src="../assets/img/1-2.jpg" alt="logo" /></a></div>
                                    <div className="item"><a href="#"><img src="../assets/img/2-2.jpg" alt="logo" /></a></div>
                                    <div className="item"><a href="#"><img src="../assets/img/3-2.jpg" alt="logo" /></a></div>
                                    <div className="item"><a href="#"><img src="../assets/img/4.jpg" alt="logo" /></a></div>
                                    <div className="item"><a href="#"><img src="../assets/img/5.jpg" alt="logo" /></a></div>
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default About;